import { Component, Input } from '@angular/core'
import {
  MbCheckoutBaseFormPartialComponent
} from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'

@Component({
  selector: 'mb-checkout-country-form-partial',
  templateUrl: './mb-checkout-country-form-partial.component.html'
})
export class MbCheckoutCountryFormPartialComponent extends MbCheckoutBaseFormPartialComponent {

  @Input() isCountryDisabled = true
  @Input() countryLabelKey: string = 'mbcommon.country'
}
